<script lang="ts">
  import { mloc } from "module/utils";
  import type { HelpItem, SearchResultItemProps } from "../SearchControllers";

  let { resultItem, selected, callAction }: SearchResultItemProps = $props();

  let item = resultItem.item as HelpItem;
</script>

<li class:search-selected={selected} class="no-icon-result">
  <a onclick={() => callAction({ item })}>
    <span class="title">{item.name}</span>
    <span class="sub">{mloc(item.description)}</span>
  </a>
</li>

<style>
  .title {
    min-width: auto;
  }
</style>
